import * as React from 'react';
import type { DropdownBaseProps, DropdownMultipleProps } from '../Dropdown/Dropdown';
import Dropdown from '../Dropdown/Dropdown';
import type { Distribute } from '../../../modules/ts.utils';
import SearchField from '../SearchField/SearchField';
import Tokens from '../TokenInput/Tokens';
import cn from '~modules/cn';

import './dropdown-multiple-filter.scss';

type Props<T> = DropdownBaseProps<T> &
    Omit<DropdownMultipleProps<T>, 'multiple'> & {
        renderChipTitle?: boolean;
        maxTokens?: number;
        grow?: boolean;
    };

const DropdownMultipleFilter = <T extends string | number>(props: Props<T>) => {
    const [filterValue, setFilterValue] = React.useState('');

    const filterValueLower = filterValue.toLowerCase();
    const renderOptions = filterValue ? props.options?.filter((opt) => opt.name.toLowerCase().includes(filterValueLower)) : props.options;

    const valueOptions = props.value.map((value) => props.options?.find((option) => option.value === value));

    return (
        <Dropdown
            {...props}
            multiple
            showCheckbox
            useFocusControls={false}
            onFocusChange={(state) => !state && setFilterValue('')}
            className={cn('dropdown-multiple-filter', props.className, { 'dropdown-multiple-filter--grow': props.grow })}
            dataTip={
                props.value.length
                    ? valueOptions
                          .map((opt) => opt?.name)
                          .filter(Boolean)
                          .join(', ')
                    : undefined
            }
            renderTitle={
                props.renderTitle ??
                (() =>
                    valueOptions.length > 0 ? (
                        <Tokens
                            values={valueOptions.map((option) => ({
                                title: option?.name,
                                icon: option?.leftView
                            }))}
                            onRemove={(index) => {
                                const newValues = props.value.slice();
                                newValues.splice(index, 1);
                                props.onChange?.(newValues as Distribute<T>);
                            }}
                            max={props.maxTokens}
                            disabled={props.disabled}
                        />
                    ) : (
                        <span>{props.placeholder}</span>
                    ))
            }
            renderOptions={renderOptions}
            menuClassName="dropdown-multiple-filter__tooltip"
            defaultListChildren={
                <SearchField
                    className="dropdown-multiple-filter__search"
                    placeholder="Search"
                    value={filterValue}
                    onChange={(e) => setFilterValue(e.target.value)}
                />
            }
        />
    );
};

export default DropdownMultipleFilter;
